import React from 'react';
import LinkTo from './LinkTo';

export default () => (
  <LinkTo to="/">
    <>
      <img className="header-logo" src={`${process.env.TARGET}static/logos/logo.png`} alt="logo" />
      <img
        className="header-slogan"
        src={`${process.env.TARGET}static/logos/slogan.gif`}
        alt="logo"
      />
    </>
  </LinkTo>
);
